import { SimpleGrid, AspectRatio, Box, BoxProps, Modal, ModalContent, ModalBody, useDisclosure } from '@chakra-ui/react'
import * as React from 'react'

import { TextBody, TextBodyBold2, TextHeadline1 } from '../common/Text'
import { useResponsive } from '../../hooks/useResponsive'
import { vw } from '../../styles/theme'
import ArtistsModal from '../artists/ArtistsModal'
import Button from '../buttons/Button'
import Image from '../common/Image'

export type TopArchiveProps = BoxProps & {
  products: { thumb: string; image: string; title: string; credit: string }[]
}

const TopArchive: React.FC<TopArchiveProps> = ({ products, ...others }) => {
  const platform = useResponsive('sp', 'pc')
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [selectedItem, setSelectedItem] = React.useState(0)

  const handleClick = (i: number) => {
    setSelectedItem(i)
    onOpen()
  }
  return (
    <>
      <Box pt={[vw(150), '200px']} pb={[vw(150), '100px']} {...others}>
        <Box w={['contentSP', '660px']} m="0 auto" textAlign={['center', 'left']}>
          <Box mb={[vw(60), '60px']}>
            <TextHeadline1 as="h2" localizeKey="top__archive__title" lineHeight="1" />
          </Box>

          <Box mb={[vw(60), '50px']}>
            <SimpleGrid columns="2" spacingX={[vw(30), '30px']} spacingY={[vw(30), '30px']}>
              {products.map((product, i) => {
                return (
                  <Box key={i} as="button" onClick={() => handleClick(i)}>
                    <Image src={product.thumb} w={[vw(260), '315px']} h={[vw(260), '315px']} />
                  </Box>
                )
              })}
            </SimpleGrid>
          </Box>

          <Box mb={[vw(60), '50px']}>
            <AspectRatio maxW="100%" ratio={560 / 315} mb={[vw(30), '30px']}>
              <iframe
                src="https://www.youtube.com/embed/lNn_G2x1LeU"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </AspectRatio>

            <AspectRatio maxW="100%" ratio={560 / 315}>
              <iframe
                src="https://www.youtube.com/embed/ABT2_WcTjb8"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </AspectRatio>
          </Box>

          <Box>
            <TextBodyBold2 localizeKey={'top__archive__web_2019_title'} />
            <TextBody localizeKey={'top__archive__web_2019_body'} />
          </Box>
        </Box>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="full" motionPreset="slideInBottom">
        <ModalContent>
          <ModalBody bg="black">
            <Button
              variant="unstyled"
              onClick={onClose}
              pos="absolute"
              top="0"
              left={['auto', '0']}
              right={['0', 'auto']}
              w={[vw(109), '38px']}
              h={[vw(109), '38px']}
            >
              <Image src={`/images/modal_close_${platform}.png`} w={[vw(109), '38px']} h="auto" />
            </Button>
            <ArtistsModal index={selectedItem} products={products} onClick={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default TopArchive
